<template>
    <div class="dropdown-menu dropdown-apps" aria-labelledby="dropdownShortcutMenu" style="top: 15px !important;">
        <div class="search-group">
            <div class="input-search">
                <i class="input-search-icon icon-magnify" aria-hidden="true"></i>
                <input type="text" class="search-control" name="" placeholder="Search..." autocomplete="off" v-model="search_key" @input="filterProducts()">
            </div>
        </div>
        <header class="row no-gutters align-items-center justify-content-between bg-white text-auto headerproducts">
            <div class="title h6 text-secondary">Purchased Products</div>
            <div class="more text-muted">
                <span class="viewtxt">View All</span>
                <span class="switch switch-md">
                    <input type="checkbox" class="switch" id='fuel-alert' v-model="value">
                    <label for='fuel-alert'></label>
                </span>
            </div>
        </header>
        <img class="border-img" src="https://cdn.digicollect.com/cdn/dccloud/static/images/header-bottom.svg">
        <div v-if="filter_purchased_product.length == 0" class="text-center">
            <span class="fw-500" v-if="search_key.length">No Search Result Found</span>
            <span class="fw-500" v-else>No Purchased Products</span>
        </div>
        <div class="d-flex flex-wrap uk-grid uk-grid-width-medium-1-3 uk-margin-bottom uk-text-center" v-else>
            <a :href="product.public_url" target="_blank" class="logoblock mt-0" v-for="product in filter_purchased_product" :key="product._id">
                <i v-if="product.product_name == 'Accounting'" class="logo-accounting-bookeeping material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'Chat'" class="logo-chat material-icons md-36 md-color-light-green-600"></i>
                <i v-if="product.product_name == 'Cloud'" class="logo-cloud material-icons md-36 md-color-orange-600" style="width: 46px;"></i>
                <i v-if="product.product_name == 'Contract Management'" class="logo-contract-management material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'DigiAds'" class="logo-ads material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'DigiPOS'" class="logo-pos material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'SCM'" class="logo-scm material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'Forms'" class="logo-forms material-icons md-36 md-color-cyan-600"></i>
                <i v-if="product.product_name == 'DigiPlay'" class="logo-play material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'Expense Management'" class="logo-expence-management material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'FlatViz'" class="logo-flatviz material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'DigiHelp'" class="logo-help-desk material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'HRMS'" class="logo-hrms material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'IMS'" class="logo-ims material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'Marketplace'" class="logo-marketplace material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'MFI'" class="logo-mfi material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'PerfMon'" class="logo-monitoring material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'SecureMon'" class="logo-monitoring material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'SiteViz'" class="logo-siteviz material-icons md-36 md-color-orange-600"></i>
                <span class="uk-text-muted uk-display-block">{{product.product_name}}</span>
            </a>
        </div>
        <header class="row no-gutters align-items-center justify-content-between bg-white text-auto headerproducts pt-4">
            <div class="title h6 text-secondary">All Products</div>
        </header>
        <img class="border-img" src="https://cdn.digicollect.com/cdn/dccloud/static/images/header-bottom.svg">
        <div v-if="filter_allProduct.length == 0" class="text-center pb-4">
            <span class="fw-500" v-if="search_key.length">No Search Result Found</span>
            <span class="fw-500" v-else>No Products Found</span>
        </div>
        <div class="d-flex flex-wrap uk-grid uk-grid-width-medium-1-3 uk-margin-bottom uk-text-center" v-else>
            <a :href="product.public_url" target="_blank" class="logoblock mt-0" v-for="product in filter_allProduct" :key="product._id">
                <i v-if="product.product_name == 'Accounting'" class="logo-accounting-bookeeping material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'Chat'" class="logo-chat material-icons md-36 md-color-light-green-600"></i>
                <i v-if="product.product_name == 'Cloud'" class="logo-cloud material-icons md-36 md-color-orange-600" style="width: 46px;"></i>
                <i v-if="product.product_name == 'Contract Management'" class="logo-contract-management material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'DigiAds'" class="logo-ads material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'DigiPOS'" class="logo-pos material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'SCM'" class="logo-scm material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'Forms'" class="logo-forms material-icons md-36 md-color-cyan-600"></i>
                <i v-if="product.product_name == 'DigiPlay'" class="logo-play material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'Expense Management'" class="logo-expence-management material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'FlatViz'" class="logo-flatviz material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'DigiHelp'" class="logo-help-desk material-icons md-36 md-color-blue-600"></i>
                <i v-if="product.product_name == 'HRMS'" class="logo-hrms material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'IMS'" class="logo-ims material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'Marketplace'" class="logo-marketplace material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'MFI'" class="logo-mfi material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'PerfMon'" class="logo-monitoring material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'SecureMon'" class="logo-monitoring material-icons md-36 md-color-orange-600"></i>
                <i v-if="product.product_name == 'SiteViz'" class="logo-siteviz material-icons md-36 md-color-orange-600"></i>
                <span class="uk-text-muted uk-display-block">{{product.product_name}}</span>
            </a>
        </div>
    </div>
</template>
<script>
import crm from "./mixins/crm.js"
export default {
    mixins:[crm],
    data(){
        return{
            allProduct:[],
            purchased_product:[],
            search_key:'',
            filter_purchased_product:[],
            filter_allProduct:[],
            value:false
        }
    },
    methods:{
        async getAllDigiProducts(){
            try {
                let res = await this.getProductsPurchasedAndNotPurchased()
                if(res.status_id == 1){
                    if(res.response && res.response.purchased_products){
                        this.purchased_product  = res.response.purchased_products
                        this.filter_purchased_product = res.response.purchased_products
                        let pp = res.response.purchased_products
                        let npp = res.response.not_purchased_products
                        this.allProduct = pp.concat(npp);
                        this.filter_allProduct = pp.concat(npp);
                    }
                }
            } catch (reason) {
                
            }
        },
        filterProducts() {
            this.filter_purchased_product = []
            this.filter_allProduct = []
            for (var i = 0; i <= this.purchased_product.length; i++) {
                if (this.purchased_product[i] && this.purchased_product[i].product_name.match(new RegExp(this.search_key.trim(), 'gi'))) {
                    this.filter_purchased_product.push(this.purchased_product[i])
                }
            }
            for (var i = 0; i <= this.allProduct.length; i++) {
                if (this.allProduct[i] && this.allProduct[i].product_name.match(new RegExp(this.search_key.trim(), 'gi'))) {
                    this.filter_allProduct.push(this.allProduct[i])
                }
            }
            if (this.search_key.trim().length == 0){
                this.filter_purchased_product = this.purchased_product
                this.filter_allProduct = this.allProduct
            } 
        }
    },
    async mounted(){
        this.getAllDigiProducts()
    }
}
</script>
<style scoped>
.header{
    display: flex;
    color: #fff;
    align-items: center;
    justify-content: space-between;
}
.dropdown-apps {
    width: 320px;
    min-height: 100px;
    max-height: 400px;
    overflow-y: auto;
    top: 11px !important;
}
.dropdown-menu {
    -webkit-border-radius: 8px!important;
    border-radius: 8px!important;
    border: 1px solid #cdd2da!important;
    -webkit-box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
    box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
}
.uk-margin-bottom {
    margin-bottom: 16px !important;
}
.uk-grid:after,
.uk-grid:before {
    content: "";
    display: block;
    overflow: hidden;
}
[class*="uk-grid-width"] > * {
    box-sizing: border-box;
    width: 100%;
}
.uk-grid-width-medium-1-3 > * {
     width: 33.333%;
}
.uk-margin-top {
    margin-top: 15px !important;
}
@media (min-width: 1220px) {
    .uk-grid > * {
        padding-left: 0px;
    }
}
.uk-grid > * {
    -ms-flex: none;
    -webkit-flex: none;
    flex: none;
    margin: 0;
    float: left;
    text-align: center;
    text-decoration: none;
}
.uk-grid > *:hover {
    text-decoration: none;
}
i.material-icons.md-36 {
    font-size: 36px !important;
    vertical-align: -36px;
    line-height: 36px;
    height: 36px;
    width: 36px;
    padding-bottom: 15px;
    color: #005dae !important;
}
.uk-grid > * > :last-child {
    margin-bottom: 0;
}
.uk-text-muted {
    color: #212121 !important;
}
.uk-display-block {
    display: block !important;
}
.logoblock .uk-display-block {
    margin-top: 8px;
}
div.title.h6 {
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: 0.6px;
    color: #005dae;
}
.border-img {
    width: 202px;
    height: 2px;
    object-fit: contain;
    border-radius: 19px;
    padding-left: 10px;
    margin-bottom: 5px;
}
.headerproducts {
    padding: 5px 10px 0px 10px;
}
.viewtxt {
    font-size: 12px;
    font-weight: 600;
    line-height: 1.25;
    letter-spacing: 0.5px;
    color: #303031;
    padding-right: 6px;
}
.search-group {
    margin-bottom: 0px;
    padding: 10px 10px;
}
.input-search {
    position: relative;
}
.input-search .input-search-close, .input-search .input-search-icon {
    position: absolute;
    top: 50%;
    z-index: 1;
    width: 2.573rem;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
}
.input-search .input-search-icon {
    left: 0px;
    font-size: 16px;
    color: #005dae;
    text-align: center;
    pointer-events: none;
    width: 16px;
    height: 16px;
    line-height: 16px;
}
.input-search .input-search-icon+.search-control {
    padding-left: 2.4rem;
}
.search-control:focus + .input-search .input-search-icon {
    color: #005dae !important;
}
.search-control {
    height: 2.573rem;
    -webkit-appearance: none;
    border-color: #005dae;
    -webkit-box-shadow: none;
    box-shadow: none;
    -webkit-transition: -webkit-box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -o-transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    transition: box-shadow .25s linear,border .25s linear,color .25s linear,background-color .25s linear;
    -moz-appearance: none;
}
.search-control {
    display: block;
    width: 100%;
    padding: .429rem 1.072rem;
    font-size: 14px;
    line-height: 1.571429;
    color: #303031;
    background-color: #fff;
    background-image: none;
    -webkit-background-clip: padding-box;
    background-clip: padding-box;
    border-bottom: 1px solid #cdd2da !important;
    border-radius: 0px;
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    overflow: visible;
    margin: 0;
}
.search-control:focus {
    border-color: #005dae !important;
}
button.input-search-close {
    -webkit-appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
}
.input-search-close.icon {
    font-size: 16px;
    line-height: 16px;
}
.input-search .input-search-close {
    right: 8px;
}

</style>
